import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const SuccessMessage = () => {
  return (
    <div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};
